// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.working-hours-label {
  margin-top: 20px;
  background: #f0f8f6;
  border: 1px solid #d6e7e4;
  border-radius: 8px;
  height: 68px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
}
.working-hours-label__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #075453;
}
.working-hours-label__setting {
  margin-left: auto;
  display: flex;
}
.working-hours-label__setting__text {
  margin-left: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #49ae9e;
}`, "",{"version":3,"sources":["webpack://./src/components/staff-registration/working-hours-label/working-hours-label.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AADJ;AAGI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EACI,iBAAA;EACA,aAAA;AAFR;AAIQ;EACI,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ","sourcesContent":[".working-hours-label {\n    margin-top: 20px;\n\n    background: #f0f8f6;\n    border: 1px solid #d6e7e4;\n    border-radius: 8px;\n    height: 68px;\n\n    display: flex;\n    align-items: center;\n    padding-left: 20px;\n    padding-right: 20px;\n\n    &__text {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        color: #075453;\n    }\n\n    &__setting {\n        margin-left: auto;\n        display: flex;\n\n        &__text {\n            margin-left: 10px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 12px;\n            line-height: 18px;\n            color: #49ae9e;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
